import { useEffect } from 'react';

export default function ServiceModal({ isOpen, onClose, service }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }
    
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen || !service) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close modal">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
        
        <div className="modal-content">
          <div className="modal-header">
            <div className="text-5xl mb-4 animate-bounce-slow">{service.icon}</div>
            <h2 className="text-3xl font-bold text-white mb-2">{service.title}</h2>
            <p className="text-lg text-gray-100">{service.desc}</p>
          </div>
          
          <div className="modal-body">
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold text-white mb-3 flex items-center gap-2">
                  <span>✨</span> Key Features
                </h3>
                <ul className="space-y-2">
                  {service.bullets?.map((bullet, index) => (
                    <li key={index} className="flex items-start gap-3 text-gray-100">
                      <span className="text-amber-400 text-xl mt-1">✓</span>
                      <span>{bullet}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-white mb-3 flex items-center gap-2">
                  <span>🎯</span> Who It's For
                </h3>
                <div className="grid gap-3 md:grid-cols-2">
                  {service.targetAudience?.map((audience, index) => (
                    <div key={index} className="card rounded-xl border border-white/30 bg-white/10 backdrop-blur-md px-4 py-3 text-sm">
                      <p className="text-white font-medium">{audience}</p>
                    </div>
                  ))}
                </div>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-white mb-3 flex items-center gap-2">
                  <span>⏱️</span> Typical Timeline
                </h3>
                <div className="card rounded-xl border border-white/30 bg-white/10 backdrop-blur-md p-4">
                  <p className="text-2xl font-bold text-amber-300">{service.timeline}</p>
                  <p className="text-sm text-gray-100 mt-1">From concept to deployment</p>
                </div>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-white mb-3 flex items-center gap-2">
                  <span>💎</span> What You Get
                </h3>
                <div className="grid gap-2 md:grid-cols-2">
                  {service.deliverables?.map((deliverable, index) => (
                    <div key={index} className="flex items-center gap-2 text-gray-100 text-sm">
                      <span className="text-green-400">●</span>
                      <span>{deliverable}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          
          <div className="modal-footer">
            <div className="flex flex-wrap gap-3">
              <a href="/contact" className="btn-gold flex-1 text-center">
                Get Started →
              </a>
              <a href="/portfolio" className="link-gold flex-1 text-center">
                View Examples
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
